import React from "react";
import { Helmet } from "react-helmet";

export default function PrivacyPolicy() {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy || TamizhTechie</title>
        <meta name="description" content="Privacy Policy" />
      </Helmet>
      <div className="privacypolicy">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1>Privacy Policy</h1>
              <h2>Last updated: July 07, 2021</h2>
              <br />
              <br />
              <h6>
                This Privacy Policy describes Our policies and procedures on the
                collection, use and disclosure of Your information when You use
                the Service and tells You about Your privacy rights and how the
                law protects You.
              </h6>
              <br />
              <h6>
                We use Your Personal data to provide and improve the Service. By
                using the Service, you agree to the collection and use of
                information in accordance with this Privacy Policy.{" "}
              </h6>
              <br />
              <h3>Interpretation and Definitions</h3>
              <h4>Interpretation</h4>
              <h6>
                The words of which the initial letter is capitalized have
                meanings defined under the following conditions. The following
                definitions shall have the same meaning regardless of whether
                they appear in singular or in plural.
              </h6>
              <br />
              <h4>Definitions</h4>
              <h6>For the purposes of this Privacy Policy:</h6>
              <ul>
                <li>
                  Account means a unique account created for You to access our
                  Service or parts of our Service.
                </li>
                <li>
                  Company (referred to as either "the Company", "We", "Us" or
                  "Our" in this Agreement) refers to TamizhTechie.
                </li>
                <li>
                  Cookies are small files that are placed on Your computer,
                  mobile device or any other device by a website, containing the
                  details of Your browsing history on that website among its
                  many uses.
                </li>
                <li>Country refers to: Tamil Nadu, India</li>
                <li>
                  Device means any device that can access the Service such as a
                  computer, a cellphone or a digital tablet.
                </li>
                <li>
                  Personal Data is any information that relates to an identified
                  or identifiable individual.
                </li>
                <li>Service refers to the Website</li>
                <li>
                  Service Provider means any natural or legal person who
                  processes the data on behalf of the Company. It refers to
                  third-party companies or individuals employed by the Company
                  to facilitate the Service, to provide the Service on behalf of
                  the Company, to perform services related to the Service or to
                  assist the Company in analyzing how the Service is used.
                </li>
                <li>
                  Usage Data refers to data collected automatically, either
                  generated by the use of the Service or from the Service
                  infrastructure itself (for example, the duration of a page
                  visit).
                </li>
                <li>
                  Website refers to TamizhTechie, accessible from
                  <a href="https://tamizhtechie.com">
                    https://tamizhtechie.com
                  </a>
                </li>
                <li>
                  You means the individual accessing or using the Service, or
                  the company, or other legal entity on behalf of which such
                  individual is accessing or using the Service, as applicable.
                </li>
              </ul>
              <br />
              <h3>Collecting and Using Your Personal Data</h3>
              <h4>Types of Data Collected</h4>
              <p>Personal Data</p>
              <h6>
                While using Our Service, We may ask You to provide Us with
                certain personally identifiable information that can be used to
                contact or identify You. Personally identifiable information may
                include, but is not limited to:
              </h6>
              <ul>
                <li>First name and last name</li>
                <li>Usage Data</li>
              </ul>
              <p>Usage Data</p>
              <h6>
                Usage Data is collected automatically when using the Service.
              </h6>
              <br />
              <h6>
                Usage Data may include information such as Your Device's
                Internet Protocol address (e.g. IP address), browser type,
                browser version, the pages of our Service that You visit, the
                time and date of Your visit, the time spent on those pages,
                unique device identifiers and other diagnostic data.
              </h6>
              <br />
              <h6>
                When You access the Service by or through a mobile device, We
                may collect certain information automatically, including, but
                not limited to, the type of mobile device You use, Your mobile
                device unique ID, the IP address of Your mobile device, Your
                mobile operating system, the type of mobile Internet browser You
                use, unique device identifiers and other diagnostic data.
              </h6>
              <br />
              <h6>
                We may also collect information that Your browser sends whenever
                You visit our Service or when You access the Service by or
                through a mobile device.
              </h6>
              <br />
              <p>Tracking Technologies and Cookies</p>

              <h6>
                We never use Cookies and similar tracking technologies to track
                the activity on Our Service and store certain information. Some
                of the Tracking technologies are to improve and analyze Our
                Service.
              </h6>
              <br />
              <h4>Use of Your Personal Data</h4>
              <h6>
                The Company may use Personal Data for the following purposes:
              </h6>
              <ul>
                <li>
                  To provide and maintain our Service, including to monitor the
                  usage of our Service.
                </li>
                <li>
                  To manage Your requests: To attend and manage Your requests to
                  Us.
                </li>
                <li>
                  For other purposes: We may use Your information for other
                  purposes, such as data analysis, identifying usage trends,
                  determining the effectiveness of our promotional campaigns and
                  to evaluate and improve our Service, products, services,
                  marketing and your experience.
                </li>
              </ul>
              <br />
              <h4>Retention of Your Personal Data</h4>
              <br />
              <h6>
                The Company will never retain Your Personal Data only for as
                long as is necessary for the purposes set out in this Privacy
                Policy.
              </h6>
              <br />
              <h4>Transfer of Your Personal Data</h4>
              <br />
              <h6>
                Your information, including Personal Data, is processed at the
                Company's operating offices and in any other places where the
                parties involved in the processing are located. It means that
                this information will never be transferred to — and maintained
                on — computers located outside of Your state, province, country
                or other governmental jurisdiction where the data protection
                laws may differ than those from Your jurisdiction.
              </h6>
              <h6>
                <br />
                Your consent to this Privacy Policy followed by Your submission
                of such information represents Your agreement to that transfer.
              </h6>
              <h6>
                The Company will take all steps reasonably necessary to ensure
                that Your data is treated securely and in accordance with this
                Privacy Policy and no transfer of Your Personal Data will take
                place to an organization or a country unless there are adequate
                controls in place including the security of Your data and other
                personal information.
              </h6>
              <br />
              <h4>Disclosure of Your Personal Data</h4>
              <p>Law enforcement</p>
              <h6>
                Under certain circumstances, the Company may be required to
                disclose Your Personal Data if required to do so by law or in
                response to valid requests by public authorities (e.g. a court
                or a government agency).
              </h6>
              <p>Other legal requirements</p>
              <h6>
                The Company may disclose Your Personal Data in the good faith
                belief that such action is necessary to:
              </h6>
              <ul>
                <li>Comply with a legal obligation</li>
                <li>
                  Protect and defend the rights or property of the Company
                </li>
                <li>
                  Prevent or investigate possible wrongdoing in connection with
                  the Service
                </li>
                <li>
                  Prevent or investigate possible wrongdoing in connection with
                  the Service
                </li>
                <li>
                  Protect the personal safety of Users of the Service or the
                  public
                </li>
                <li>Protect against legal liability</li>
              </ul>
              <br />
              <h4>Security of Your Personal Data</h4>
              <h6>
                The security of Your Personal Data is important to Us, but
                remember that no method of transmission over the Internet, or
                method of electronic storage is 100% secure. While We strive to
                use commercially acceptable means to protect Your Personal Data,
                We cannot guarantee its absolute security.
              </h6>
              <br />
              <h3>Links to Other Websites</h3>
              <h6>
                Our Service may contain links to other websites that are not
                operated by Us. If You click on a third party link, You will be
                directed to that third party's site. We strongly advise You to
                review the Privacy Policy of every site You visit.
              </h6>
              <h6>
                We have no control over and assume no responsibility for the
                content, privacy policies or practices of any third party sites
                or services.
              </h6>
              <br />
              <h3>Changes to this Privacy Policy</h3>
              <h6>
                We may update Our Privacy Policy from time to time. We will
                notify You of any changes by posting the new Privacy Policy on
                this page.
              </h6>
              <h6>
                We will let You know via email and/or a prominent notice on Our
                Service, prior to the change becoming effective and update the
                "Last updated" date at the top of this Privacy Policy.
              </h6>
              <h6>
                You are advised to review this Privacy Policy periodically for
                any changes. Changes to this Privacy Policy are effective when
                they are posted on this page.
              </h6>
              <br />
              <h3>Contact Us</h3>
              <h6>
                If you have any questions about this Privacy Policy, You can
                contact us:
              </h6>
              <ul>
                <li>
                  By email:{" "}
                  <a href="tamizhtechie@gmail.com">tamizhtechie@gmail.com</a>{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
